var _path, _ellipse, _path2, _ellipse2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadCellBuffer = function SvgLoadCellBuffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 196 249"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    stroke: "#4F4F4F",
    strokeWidth: 4,
    d: "M51.473 246.461c24.009 0 43.472-7.376 43.472-16.475V218.5H8v11.486c0 9.099 19.463 16.475 43.473 16.475Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5,
    cy: 218,
    fill: "#BDBDBD",
    stroke: "#4F4F4F",
    strokeWidth: 4,
    rx: 43.5,
    ry: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A246",
    stroke: "#4F4F4F",
    strokeWidth: 4,
    d: "M150.473 246.461c24.009 0 43.472-7.376 43.472-16.475V218.5H107v11.486c0 9.099 19.463 16.475 43.473 16.475Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 218,
    fill: "#F7A246",
    stroke: "#4F4F4F",
    strokeWidth: 4,
    rx: 43.5,
    ry: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C94C",
    d: "M62 20.5v39h68v33.189h-20L150 135l40-42.311h-20V20.5zM55 59.5h-6v-39h6zM40 20.5h-6v39h6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M62 20.5v39h68v33.189h-20L150 135l40-42.311h-20V20.5zM55 59.5h-6v-39h6zM40 20.5h-6v39h6z"
  })));
};
export { SvgLoadCellBuffer as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk2IiBoZWlnaHQ9IjI0OSIgdmlld0JveD0iMCAwIDE5NiAyNDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01MS40NzI3IDI0Ni40NjFDNzUuNDgyIDI0Ni40NjEgOTQuOTQ1NCAyMzkuMDg1IDk0Ljk0NTQgMjI5Ljk4NlYyMTguNUg4VjIyOS45ODZDOCAyMzkuMDg1IDI3LjQ2MzQgMjQ2LjQ2MSA1MS40NzI3IDI0Ni40NjFaIiBmaWxsPSIjQkRCREJEIiBzdHJva2U9IiM0RjRGNEYiIHN0cm9rZS13aWR0aD0iNCIvPgo8ZWxsaXBzZSBjeD0iNTEuNSIgY3k9IjIxOCIgcng9IjQzLjUiIHJ5PSIxNSIgZmlsbD0iI0JEQkRCRCIgc3Ryb2tlPSIjNEY0RjRGIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTE1MC40NzMgMjQ2LjQ2MUMxNzQuNDgyIDI0Ni40NjEgMTkzLjk0NSAyMzkuMDg1IDE5My45NDUgMjI5Ljk4NlYyMTguNUgxMDdWMjI5Ljk4NkMxMDcgMjM5LjA4NSAxMjYuNDYzIDI0Ni40NjEgMTUwLjQ3MyAyNDYuNDYxWiIgZmlsbD0iI0Y3QTI0NiIgc3Ryb2tlPSIjNEY0RjRGIiBzdHJva2Utd2lkdGg9IjQiLz4KPGVsbGlwc2UgY3g9IjE1MC41IiBjeT0iMjE4IiByeD0iNDMuNSIgcnk9IjE1IiBmaWxsPSIjRjdBMjQ2IiBzdHJva2U9IiM0RjRGNEYiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNNjIgMjAuNVY1OS41SDEzMFY5Mi42ODg5SDExMEwxNTAgMTM1TDE5MCA5Mi42ODg5SDE3MFYyMC41SDYyWiIgZmlsbD0iI0YyQzk0QyIvPgo8cGF0aCBkPSJNNTUgNTkuNUg0OVYyMC41SDU1VjU5LjVaIiBmaWxsPSIjRjJDOTRDIi8+CjxwYXRoIGQ9Ik00MCAyMC41SDM0VjU5LjVINDBWMjAuNVoiIGZpbGw9IiNGMkM5NEMiLz4KPHBhdGggZD0iTTYyIDIwLjVWNTkuNUgxMzBWOTIuNjg4OUgxMTBMMTUwIDEzNUwxOTAgOTIuNjg4OUgxNzBWMjAuNUg2MloiIHN0cm9rZT0iIzRGNEY0RiIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTU1IDU5LjVINDlWMjAuNUg1NVY1OS41WiIgc3Ryb2tlPSIjNEY0RjRGIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNDAgMjAuNUgzNFY1OS41SDQwVjIwLjVaIiBzdHJva2U9IiM0RjRGNEYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";